/**
 * @Description 项目点评
 */

import { FC, useEffect, useRef, useState } from 'react';
import styles from './index.module.less';
import Header from '../Header';
import PPTMap from '../Map';
import { useMethods } from '@lhb/hook';

const PlaceComment:FC<any> = ({
  rangeName,
  lnglat,
  range,
  data
}) => {

  const mapRef:any = useRef();
  const [mapIns, setMapIns] = useState<any>();

  const methods = useMethods({
    onMapReady(_mapIns) {
      setMapIns(_mapIns);
    },
  });

  useEffect(() => {
    if (!mapIns || !lnglat?.lng || !lnglat?.lat || !range) return;
    mapRef?.current?.addMarkerCircle(lnglat?.lng, lnglat?.lat, range);
  }, [mapIns, lnglat, range]);

  return (
    <div className={styles['page']}>
      <Header title={`项目点评 — ${rangeName}`}/>

      <div className={styles['page-content']}>
        <div className={styles['left']}>
          <div className={styles['user']}>
            <img src={data?.avatar} className={styles['user-avatar']} />
            <div className={styles['user-name']}>{data?.username}</div>
          </div>

          <div className={styles['content']}>
            <div className={styles['tag-list']}>
              {data.tags?.map((item, index) => {
                return (
                  <div key={index} className={styles['item']}>#{item}</div>
                );
              })}
            </div>

            <div className={styles['comment']}>
              {data?.comment}
            </div>
          </div>
        </div>

        <div className={styles['right']}>
          <PPTMap
            height={807}
            ref={mapRef}
            onMapReady={methods.onMapReady}/>
        </div>
      </div>

    </div>
  );
};

export default PlaceComment;
